/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Department } from '../../models/department';

export interface GetDepartments$Params {
}

export function getDepartments(http: HttpClient, rootUrl: string, params?: GetDepartments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Department>>> {
  const rb = new RequestBuilder(rootUrl, getDepartments.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Department>>;
    })
  );
}

getDepartments.PATH = '/departments';
